import { NoSsr } from "@mui/base";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { topicCollectionHeaderRelatedLinksConnection$key } from "scmp-app/queries/__generated__/topicCollectionHeaderRelatedLinksConnection.graphql";

import {
  Container,
  Label,
  StyledBaseLink,
  StyledSwiper,
  StyledSwiperSlide,
  SwiperContainer,
} from "./styles";

type Props = {
  className?: string;
  label?: string;
  reference: topicCollectionHeaderRelatedLinksConnection$key;
};

export const TopicCollectionHeaderRelatedLinks: FunctionComponent<Props> = ({
  className,
  label,
  reference: reference_,
}) => {
  const queueItemConnection = useFragment(
    graphql`
      fragment topicCollectionHeaderRelatedLinksConnection on QueueItemConnection {
        edges {
          node {
            ... on Topic {
              name
              urlAlias
            }
          }
        }
      }
    `,
    reference_,
  );

  const relatedTopics = queueItemConnection.edges.map(edge => edge.node) ?? [];

  return (
    <Container className={className}>
      <SwiperContainer>
        <StyledSwiper cssMode={false} pagination={false} slidesPerView="auto">
          <StyledSwiperSlide key="0">
            <Label>{label ?? "Related Topics:"}</Label>
          </StyledSwiperSlide>
          {relatedTopics?.map((topic, index) => (
            <StyledSwiperSlide key={index}>
              <NoSsr>
                <StyledBaseLink pathname={topic.urlAlias ?? ""}>{topic?.name}</StyledBaseLink>
              </NoSsr>
            </StyledSwiperSlide>
          ))}
        </StyledSwiper>
      </SwiperContainer>
    </Container>
  );
};

TopicCollectionHeaderRelatedLinks.displayName = "TopicCollectionHeaderRelatedLinks";
